<template>
  <div>
    <div class="callback">
      <div class="mathList" @click="(handleMath($event))">
        <div class="mathItems" @click="handleMouseStatus('enter')">
          <span class="iconfont">&#xe65f;</span>
          <span>图像生成</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xead0;</span>
          <span>智能抠图</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xe765;</span>
          <span>智能裁切</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xe68d;</span>
          <span>无界扩图</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xe855;</span>
          <span>超清修复</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xe68e;</span>
          <span>万物迁移</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xe779;</span>
          <span>智能修复</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xe6c1;</span>
          <span>替换甲片</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xeb7a;</span>
          <span>肤质增强</span>
        </div>
        <div class="mathItems">
          <span class="iconfont">&#xe6b4;</span>
          <span>图像编辑</span>
        </div>
      </div>
      <div class="modelList" @click="handleModelsItems">
        <div class="modelsItems" style="text-decoration: line-through; opacity: 0.7; cursor: default;">
          <span class="iconfont">&#xe6a5;</span>
          <span>Qwen-Image</span>
        </div>
        <div class="modelsItems" style="text-decoration: line-through; opacity: 0.7; cursor: default;">
          <span class="iconfont">&#xe697;</span>
          <span>Kontext_Dev</span>
        </div>
        <div class="modelsItems">
          <span class="iconfont">&#xe8dc;</span>
          <span>基础模型F.1</span>
        </div>
        <div class="modelsItems">
          <span class="iconfont">&#xe69c;</span>
          <span>基础模型SDXL</span>
        </div>
        <div class="modelsItems">
          <span class="iconfont">&#xe6a1;</span>
          <span>基础模型SD1.5</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallApplication',
  props: {
    visibleCallBack: {
      type: Boolean,
      default: true
    },
    isLocked: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visibleCallBack(val) {
      if (val) {
        this.handleMathList(val)
      } if (!val) {
        this.handleMathList(val)
      }
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('keydown', this.handleEsc)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEsc)
  },
  methods: {
    handleMathList(val) {
      if (!this.isLocked) {
        if (val) {
          const mathList = document.querySelector('.mathList')
          mathList.style.height = '100%'
          mathList.style.padding = '6%'
        } else {
          const mathList = document.querySelector('.mathList')
          mathList.style.height = '0%'
          mathList.style.padding = '0%'
        }
      }
    },
    handleMouseStatus(status) {
      try {
        if (status === 'enter') {
          const modelList = document.querySelector('.modelList')
          modelList.style.height = '52%'
          modelList.style.padding = '6%'
        }
        if (status === 'close') {
          const modelList = document.querySelector('.modelList')
          modelList.style.height = '0%'
          modelList.style.padding = '0%'
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleMath(event) {
      // 检查点击的目标是否为 .mathItems 或其子元素
      const mathItem = event.target.closest('.mathItems')
      if (mathItem) {
        const secondSpan = mathItem.querySelector('span:nth-child(2)')
        if (secondSpan.textContent !== '图像生成') {
          this.$emit('handleMath', secondSpan.textContent)
          this.handleMouseStatus('close')
          this.closeModal()
        } else if (secondSpan.textContent === '图像生成') {
          if (this.time) {
            clearTimeout(this.time)
          }
          this.time = setTimeout(() => {
            this.handleMouseStatus('close')
          }, 5000)
        }
      } else {
        this.closeModal()
      }
    },
    handleModelsItems(event) {
      const modelsItems = event.target.closest('.modelsItems')
      if (modelsItems) {
        const secondSpan = modelsItems.querySelector('span:nth-child(2)')
        this.$emit('handleMath', secondSpan.textContent)
        this.handleMouseStatus('close')
      }
      this.handleMath(event)
    },
    // 退出
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.closeModal()
        const modelList = document.querySelector('.modelList')
        modelList.style.height = '0%'
        modelList.style.padding = '0%'
      }
      if (event.shiftKey && event.key === 'E') {
        this.closeModal()
        const modelList = document.querySelector('.modelList')
        modelList.style.height = '0%'
        modelList.style.padding = '0%'
      }
    },
    // 关闭窗口
    closeModal() {
      this.$emit('update:visibleCallBack', false)
    }
  }

}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 23px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.active {
  background: @basicselect;
}

.callback {
  position: absolute;
  left: 430px;
  bottom: 80px;
  width: 210px;
  height: 525px;
  pointer-events: none;

  .mathList {
    pointer-events: all;
    position: absolute;
    left: 0px;
    bottom: 0px;
    display: flex;
    background: @font_white;
    flex-direction: column;
    width: 100%;
    height: 0px;
    padding: 0px;
    color: @font_gray;
    border-radius: @border_radius_2;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    transition: all 0.5s;
    overflow-y: scroll;

    .mathItems {
      display: flex;
      justify-content: center;
      gap: 10px;
      font-size: 20px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      border-radius: @border_radius_2;
      transition: all 0.5s;
      cursor: pointer;

      &:hover {
        transition: all 0.5s;
        font-size: 22px;
        background: @basicselect;
      }

      span:nth-child(1) {
        display: block;
      }

      span:nth-child(2) {
        display: block;
      }
    }
  }

  .modelList {
    display: flex;
    position: absolute;
    pointer-events: all;
    left: 215px;
    background: @font_white;
    flex-direction: column;
    justify-content: start;
    width: 240px;
    height: 0px;
    padding: 0px;
    color: @font_gray;
    border-radius: @border_radius_2;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    transition: all 0.5s;
    cursor: pointer;
    overflow: hidden;

    .modelsItems {
      display: flex;
      justify-content: start;
      padding: 0px 20px;
      gap: 10px;
      font-size: 20px;
      line-height: 50px;
      height: 50px;
      transition: all 0.5s;
      border-radius: @border_radius_2;

      &:hover {
        transform: scale(1.05);
        transition: all 0.5s;
        background: @basicselect;
      }

      span:nth-child(1) {
        display: block;
      }

      span:nth-child(2) {
        display: block;
      }
    }
  }
}
</style>
